// #region imports

// --- Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { HttpClient } from '@angular/common/http';

// --- 3rd Party
//import { NgxSpinnerService } from 'ngx-spinner';
// import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
// import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// --- HS Code
import { AccountRoutingModule } from './account.routing-module';
import { SharedModule } from '../shared/shared.module';
import { CoreModule } from '../core/core.module';
import * as c from './';

// #endregion

@NgModule({
  declarations: [
    c.RegisterComponent,
    c.RegisterShellComponent,
    c.RegistrationConfirmedComponent,
    c.RegisteredComponent,
    c.ActivateComponent,
    c.RegistrationNavComponent,
    c.IsbnNumberModalComponent,
    c.BookComponent,
    c.LoginSignupBranchComponent,
    c.ScrollToErrorDirective,
  ],
  entryComponents: [
    c.IsbnNumberModalComponent,
  ],
  imports: [
    CommonModule,
    // NgxSpinnerService,
    SharedModule,
    AccountRoutingModule,
    CoreModule
    // TranslateModule.forChild({
    //   loader: {provide: TranslateLoader, useFactory: (createTranslateLoader), deps: [HttpClient]}
    // })
  ],
  exports: [
    c.ScrollToErrorDirective,
  ]
})
export class AccountModule { }
